module.exports = __webpack_public_path__ + "img/ER.69e357bc.jpg";